import { useSelector } from 'react-redux';
import { Country } from '../../models';
import { selectCountries } from '../../selectors';

export const useCountries = (): Country[] => {
  const countries = useSelector(selectCountries);

  return countries;
};
